/* One add request, server-checked success and the theme's shared drawer renderer. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-prink-bundle]').forEach((box) => {
      if (box.dataset.bound) return;
      const form = document.getElementById(box.dataset.formId);
      const button = box.querySelector('.bundle-offer__btn');
      const errorNode = box.querySelector('.bundle-offer__error');
      if (!form || !button || !errorNode) return;
      box.dataset.bound = 'true';
      box.hidden = false;
      box.closest('.shopify-section')?.classList.add('prink-bundle-ready');
      const label = button.textContent;
      const root = window.Shopify?.routes?.root || '/';
      const cards = Array.from(box.querySelectorAll('.bundle-card'));
      let busy = false;
      box.addEventListener('change', (event) => {
        if (!event.target.matches('.bundle-card__radio')) return;
        cards.forEach((card) => card.classList.toggle('is-selected', !!card.querySelector('input:checked')));
      });
      button.disabled = false;
      button.addEventListener('click', async () => {
        if (busy) return;
        errorNode.hidden = true;
        errorNode.replaceChildren();
        const input = form.querySelector('[name="id"]');
        const nativeButton = form.querySelector('[name="add"]');
        const quantity = Number(box.querySelector('.bundle-card__radio:checked')?.value || 1);
        if (!input?.value || input.disabled || nativeButton?.disabled || ![1, 2, 3].includes(quantity)) {
          errorNode.textContent = 'Please select an available option and try again.';
          errorNode.hidden = false;
          return;
        }
        busy = true;
        button.disabled = true;
        button.textContent = 'Adding...';
        let added = false;
        let rendered = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: input.value, quantity }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || 'This item could not be added. Please try again.');
          }
          added = true;
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') {
            window.location.assign(root + 'cart');
            return;
          }
          drawer.setActiveElement(button);
          drawer.renderContents(data);
          rendered = true;
          button.textContent = '✓ Added to cart';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'prink-bundle', productVariantId: input.value, cartData: data });
          }
        } catch (error) {
          errorNode.hidden = false;
          errorNode.textContent = added
            ? 'Your items were added. Open your cart to review them before adding again.'
            : error.message || 'Something went wrong. Please try again.';
          if (added) {
            const link = document.createElement('a');
            link.href = root + 'cart';
            link.textContent = ' Open cart';
            errorNode.appendChild(link);
          }
          button.textContent = added ? 'Added — review cart' : label;
        } finally {
          if (added && rendered) {
            setTimeout(() => { busy = false; button.disabled = false; button.textContent = label; }, 1200);
          } else if (!added) {
            busy = false;
            button.disabled = false;
          }
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
